import { required, Validator } from '@/entities/validation';
import { SsoConfiguration } from './model';
import { oAuthConfiguration, SamlConfiguration } from '@/services/api/resources/sso-configuration';

const oAuthValidationRules = (configuration: oAuthConfiguration) => {
  return [
    ...required(configuration.authorizationUri, 'configuration.authorizationUri'),
    ...required(configuration.tokenUri, 'configuration.tokenUri'),
    ...required(configuration.userInfoUri, 'configuration.userInfoUri'),
    ...required(configuration.clientId, 'configuration.clientId'),
    ...required(configuration.clientSecret, 'configuration.clientSecret'),
  ];
};

const samlValidationRules = (configuration: SamlConfiguration) => {
  return [
    ...required(configuration.entityId, 'configuration.entityId'),
    ...required(configuration.singleSignOnService, 'configuration.singleSignOnService'),
    ...required(configuration.nameIdFormat, 'configuration.nameIdFormat'),
    ...required(configuration.authorizationUri, 'configuration.authorizationUri'),
  ];
};

export const validate: Validator<SsoConfiguration> = record => {
  switch (record.identityProviderType) {
    case 'oauth2':
      return oAuthValidationRules(<oAuthConfiguration>record.configuration);
    case 'saml':
      return samlValidationRules(<SamlConfiguration>record.configuration);
    default:
      return [];
  }
};
